/*
 * COPYRIGHT: EUMETSAT 2018
 * LICENSE: PROPRIETARY
 * PROJECT: WMS
 * 
 * All information contained herein is, and remains the property of EUMETSAT.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * EUMETSAT.
 */

import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class ConfirmDialogService {

    public requestRunning = false;
    private message  = new BehaviorSubject(null);


    constructor() {
    }

    askConfirmation(message: string, title: string, onConfirm: Function, onCancel?: Function) {
        this.message.next({
            title: title,
            content: message,
            onConfirm: onConfirm,
            onCancel: onCancel
        });
    }

    close() {
        if (this.message.value.onCancel) {
            this.message.value.onCancel();
        }
        this.message.next(null);
    }

    confirm() {
        this.requestRunning = true;
        this.message.value.onConfirm().then(() => {
            this.requestRunning = false;
            this.close();
        });
    }

    getMessage() {
        return this.message.asObservable();
    }

}



// WEBPACK FOOTER //
// ./src/layout/configrm-dialog/confirm-dialog.service.ts